import { render, staticRenderFns } from "./PromoView.vue?vue&type=template&id=3a11d58a&"
import script from "./PromoView.vue?vue&type=script&lang=js&"
export * from "./PromoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3097427293/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a11d58a')) {
      api.createRecord('3a11d58a', component.options)
    } else {
      api.reload('3a11d58a', component.options)
    }
    module.hot.accept("./PromoView.vue?vue&type=template&id=3a11d58a&", function () {
      api.rerender('3a11d58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PromoView.vue"
export default component.exports